import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Alert, Table } from 'react-bootstrap';
import FormBusca from './form_busca';
import TransferenciaEstadoService from '../../../../services/transferenciasEstado-auth';
import Transferencia from './transferencia';


const ListarTransferencias = () => {

    const [transferencias, setTransferencias] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [transf, setTransf] = useState("");


    async function fetchTransferencias() {
        const response = await TransferenciaEstadoService.listar();
        if (response.data.length >= 1) {
            setTransferencias(response.data)
            setVazio(false)
        } else {
            setTransferencias([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setTransf(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a Transferência?')) {
            await TransferenciaEstadoService.deletar(id)
            alert("Transferência deletada com sucesso!")
            fetchTransferencias();
        }
    }

    useEffect(() => {
        fetchTransferencias();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/transferenciasestado/editar/${transf}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setTransferencias={setTransferencias}
                        setVazio={setVazio}
                        fetchTransferencias={fetchTransferencias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th><h5>Tributo</h5></th>
                                    <th><h5>Mês</h5></th>
                                    <th><h5>Ano</h5></th>
                                    <th><h5>Valor</h5></th>
                                    <th><h5>Tipo</h5></th>
                                    <th><h5>Programa</h5></th>
                                    <th><h5>Destinatário</h5></th>
                                    <th><h5>Editar</h5></th>
                                    <th><h5>Excluir</h5></th>
                                </tr>
                            </thead>
                            <tbody>
                                {transferencias.map((transfer, index) =>
                                    <Transferencia
                                        fetchTransferencias={fetchTransferencias}
                                        transfer={transfer}
                                        key={index}
                                        editar={handleEditar}
                                        deletar={deletar}
                                    />
                                )}
                            </tbody>
                        </Table>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarTransferencias;